import * as React from 'react'
import { ResponsiveContainer } from 'recharts'

export const ChartWrapperContext = React.createContext(true)

export function ChartWrapper(props: React.PropsWithChildren<React.ComponentProps<typeof ResponsiveContainer>>) {
  const [isTooltipActive, setTooltipActive] = React.useState(false)

  return (
    <div
      /**
       * Fix a problem with chart tooltip not hiding correctly on mouse leave
       * See: https://github.com/recharts/recharts/issues/2726
       */
      onMouseEnter={() => setTooltipActive(true)}
      onMouseLeave={() => setTooltipActive(false)}
    >
      <ChartWrapperContext.Provider value={isTooltipActive}>
        <ResponsiveContainer width="100%" {...props} />
      </ChartWrapperContext.Provider>
    </div>
  )
}
